import { Routes, Route, Navigate } from "react-router-dom";
import { AdminSchoolRoutes } from "../adminSchool/routes/AdminSchoolRoutes";
import { PublicClientRoutes } from "../public/routes/PublicClientRoutes";
import { PrivateRoutes } from "./PrivateRoute";
import { PublicRoutes } from "./PublicRoutes";

export const RouterNav = () => {
  return (
    <Routes>

      <Route path="public/*" element={
        <PublicRoutes >
          <PublicClientRoutes />
        </PublicRoutes>
      } />

      <Route path="admin/*" element={
        <PrivateRoutes >
          <AdminSchoolRoutes />
        </PrivateRoutes>
      } />

      <Route path="/*" element={<Navigate to='/public/home' />} />

    </Routes>
  )
}
